<script lang="ts">
  import SubmitButton from "../../components/SubmitButton.svelte";
  import InputNoKeydown from "../../components/Form/Fields/InputNoKeydown.svelte";
  import Form from "../../components/Form/Form.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import GlobalErrors from "../../components/GlobalErrors.svelte";
  import OutsideLayout from "../../layout/OutsideLayout.svelte";
  import { doLogin, loginErrors } from "./login.store";

  export let username: string = "";
  export let password: string = "";

  function submit() {
    doLogin(username, password);
    username = "";
    password = "";
  }
</script>

<OutsideLayout title="Accesso Riservato">
  <Form on:submit={submit}>
    <GlobalErrors errors={$loginErrors} />

    <FormField>
      <InputNoKeydown bind:value={username} name="Login" />
    </FormField>

    <FormField>
      <InputNoKeydown bind:value={password} type="password" name="Password" />
    </FormField>

    <hr class="hr" />

    <div class="field is-grouped">
      <div class="control btn-centered">
        <SubmitButton klass="is-primary">Login</SubmitButton>
      </div>
    </div>
  </Form>
</OutsideLayout>

<style>
  .btn-centered {
    margin: 0 auto;
  }

  .hr {
    border: 0;
    border-top: 1px solid #eee;
    margin: 20px 0;
  }
</style>
